type Props = { className?: string }

// Top-down full-court SVG outline used as a low-opacity watermark behind
// the landing form. `currentColor` tracks the parent's text-color so a
// dark-mode wrapper can re-tint without re-encoding the SVG. Originally
// landed in the P0 (logo-nav + court-bg) work; brought into M5 directly
// so Phase 5's two-card landing stays visually grounded.

export function CourtBackground({ className = '' }: Props) {
  return (
    <div className={`pointer-events-none select-none ${className}`} aria-hidden="true">
      <svg
        viewBox="0 0 1000 500"
        preserveAspectRatio="xMidYMid meet"
        className="w-full h-full"
      >
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
        >
          {/* Outer boundary + center line + center circle + sideline ticks */}
          <rect x="10" y="10" width="980" height="480" />
          <line x1="500" y1="10" x2="500" y2="490" />
          <circle cx="500" cy="250" r="60" />
          <line x1="500" y1="0" x2="500" y2="10" />
          <line x1="500" y1="490" x2="500" y2="500" />

          {/* Left half */}
          <path d="M 10 70 A 240 240 0 0 1 10 430" />
          <rect x="10" y="170" width="190" height="160" />
          <path d="M 200 190 A 60 60 0 0 1 200 310" />
          <path d="M 200 190 A 60 60 0 0 0 200 310" strokeDasharray="8 8" />
          <line x1="40" y1="225" x2="40" y2="275" />
          <circle cx="55" cy="250" r="8" />
          {[50, 80, 110, 140].map((x) => (
            <g key={`l-${x}`}>
              <line x1={x} y1="165" x2={x} y2="175" />
              <line x1={x} y1="325" x2={x} y2="335" />
            </g>
          ))}
          <line x1="280" y1="10" x2="280" y2="22" />
          <line x1="280" y1="478" x2="280" y2="490" />

          {/* Right half (mirrored) */}
          <path d="M 990 70 A 240 240 0 0 0 990 430" />
          <rect x="800" y="170" width="190" height="160" />
          <path d="M 800 190 A 60 60 0 0 0 800 310" />
          <path d="M 800 190 A 60 60 0 0 1 800 310" strokeDasharray="8 8" />
          <line x1="960" y1="225" x2="960" y2="275" />
          <circle cx="945" cy="250" r="8" />
          {[860, 890, 920, 950].map((x) => (
            <g key={`r-${x}`}>
              <line x1={x} y1="165" x2={x} y2="175" />
              <line x1={x} y1="325" x2={x} y2="335" />
            </g>
          ))}
          <line x1="720" y1="10" x2="720" y2="22" />
          <line x1="720" y1="478" x2="720" y2="490" />
        </g>
      </svg>
    </div>
  )
}
